const runtime = window.ThemeRuntime;
let productModules;
let productCardModules;
let facetsModules;
let infiniteLoaderModules;
let predictiveSearchModules;
let overlayModules;
let accordionModules;
let tabsModules;
let carouselModules;
let popoverModules;
let motionModules;
let headerModules;
let productRecommendationsModules;
let recentlyViewedModules;
let stickyAddToCartModules;
let rentalBundleModules;
let shopTheLookModules;
let beforeAfterModules;
let countdownModules;
let marqueeModules;
let productPromotionModules;

async function loadProductModules() {
  if (!productModules) {
    productModules = Promise.all([
      import(runtime.assets.productState),
      import(runtime.assets.variantPicker),
      import(runtime.assets.productForm),
      import(runtime.assets.deferredMedia),
      import(runtime.assets.mediaLightbox),
      import(runtime.assets.productMedia)
    ]).then(() => import(runtime.assets.product));
  }
  return productModules;
}

async function loadProductCardModules() {
  if (!productCardModules) {
    productCardModules = import(runtime.assets.productCard);
  }
  return productCardModules;
}

async function loadFacetsModules() {
  if (!facetsModules) {
    facetsModules = import(runtime.assets.facets);
  }
  return facetsModules;
}

async function loadInfiniteLoaderModules() {
  if (!infiniteLoaderModules) {
    infiniteLoaderModules = import(runtime.assets.infiniteLoader);
  }
  return infiniteLoaderModules;
}

async function loadPredictiveSearchModules() {
  if (!predictiveSearchModules) {
    predictiveSearchModules = import(runtime.assets.predictiveSearch);
  }
  return predictiveSearchModules;
}

async function loadOverlayModules() {
  if (!overlayModules) {
    overlayModules = import(runtime.assets.overlay || runtime.assets.cartOverlay);
  }
  return overlayModules;
}

async function loadAccordionModules() {
  if (!accordionModules) {
    accordionModules = import(runtime.assets.accordion);
  }
  return accordionModules;
}

async function loadTabsModules() {
  if (!tabsModules) {
    tabsModules = import(runtime.assets.tabs);
  }
  return tabsModules;
}

async function loadCarouselModules() {
  if (!carouselModules) {
    carouselModules = import(runtime.assets.carousel);
  }
  return carouselModules;
}

async function loadPopoverModules() {
  if (!popoverModules) {
    popoverModules = import(runtime.assets.popover);
  }
  return popoverModules;
}

async function loadMotionModules() {
  if (!motionModules) {
    motionModules = import(runtime.assets.motion);
  }
  return motionModules;
}

async function loadHeaderModules() {
  if (!headerModules) {
    headerModules = import(runtime.assets.header);
  }
  return headerModules;
}

async function loadProductRecommendationsModules() {
  if (!productRecommendationsModules) {
    productRecommendationsModules = import(runtime.assets.productRecommendations);
  }
  return productRecommendationsModules;
}

async function loadRecentlyViewedModules() {
  if (!recentlyViewedModules) {
    recentlyViewedModules = import(runtime.assets.recentlyViewed);
  }
  return recentlyViewedModules;
}

async function loadStickyAddToCartModules() {
  if (!stickyAddToCartModules) {
    stickyAddToCartModules = import(runtime.assets.stickyAddToCart);
  }
  return stickyAddToCartModules;
}

async function loadRentalBundleModules() {
  if (!rentalBundleModules) {
    rentalBundleModules = import(runtime.assets.rentalBundle);
  }
  return rentalBundleModules;
}

async function loadShopTheLookModules() {
  if (!shopTheLookModules) {
    shopTheLookModules = import(runtime.assets.shopTheLook);
  }
  return shopTheLookModules;
}

async function loadBeforeAfterModules() {
  if (!beforeAfterModules) {
    beforeAfterModules = import(runtime.assets.beforeAfter);
  }
  return beforeAfterModules;
}

async function loadCountdownModules() {
  if (!countdownModules) {
    countdownModules = import(runtime.assets.countdown);
  }
  return countdownModules;
}

async function loadMarqueeModules() {
  if (!marqueeModules) {
    marqueeModules = import(runtime.assets.marquee);
  }
  return marqueeModules;
}

async function mount(root = document) {
  const tasks = [];
  const containsProduct = root.matches?.('theme-product') || root.querySelector?.('theme-product');
  if (containsProduct) tasks.push(loadProductModules());

  const containsProductCard = root.matches?.('product-card') || root.querySelector?.('product-card');
  if (containsProductCard) tasks.push(loadProductCardModules());

  const containsFacets = root.matches?.('facet-controller') || root.querySelector?.('facet-controller');
  if (containsFacets) tasks.push(loadFacetsModules());

  const containsInfiniteLoader = root.matches?.('infinite-loader') || root.querySelector?.('infinite-loader');
  if (containsInfiniteLoader) tasks.push(loadInfiniteLoaderModules());

  const containsPredictiveSearch = root.matches?.('predictive-search, [data-predictive-input]') || root.querySelector?.('predictive-search, [data-predictive-input]');
  if (containsPredictiveSearch) tasks.push(loadPredictiveSearchModules());

  const containsOverlay = root.matches?.('theme-overlay, theme-drawer, theme-modal, cart-overlay, [data-overlay-open], [data-drawer-open], [data-modal-open]') ||
    root.querySelector?.('theme-overlay, theme-drawer, theme-modal, cart-overlay, [data-overlay-open], [data-drawer-open], [data-modal-open]');
  if (containsOverlay) tasks.push(loadOverlayModules());

  const containsAccordion = root.matches?.('theme-accordion, [data-accordion]') || root.querySelector?.('theme-accordion, [data-accordion]');
  if (containsAccordion) tasks.push(loadAccordionModules());

  const containsTabs = root.matches?.('theme-tabs, [role="tablist"]') || root.querySelector?.('theme-tabs, [role="tablist"]');
  if (containsTabs) tasks.push(loadTabsModules());

  const containsCarousel = root.matches?.('theme-carousel, [data-carousel-track]') || root.querySelector?.('theme-carousel, [data-carousel-track]');
  if (containsCarousel) tasks.push(loadCarouselModules());

  if (root.matches?.('collection-list-carousel') || root.querySelector?.('collection-list-carousel')) {
    tasks.push(import('./collection-list-carousel.js'));
  }

  const containsPopover = root.matches?.('theme-popover, [data-popover-trigger]') || root.querySelector?.('theme-popover, [data-popover-trigger]');
  if (containsPopover) tasks.push(loadPopoverModules());

  const containsHeader = root.matches?.('theme-header, .site-header') || root.querySelector?.('theme-header, .site-header');
  if (containsHeader) tasks.push(loadHeaderModules());

  const containsRecs = root.matches?.('product-recommendations') || root.querySelector?.('product-recommendations');
  if (containsRecs) tasks.push(loadProductRecommendationsModules());

  const containsRecentlyViewed = root.matches?.('recently-viewed-products') || root.querySelector?.('recently-viewed-products');
  if (containsRecentlyViewed) tasks.push(loadRecentlyViewedModules());

  const containsStickyAtc = root.matches?.('sticky-add-to-cart') || root.querySelector?.('sticky-add-to-cart');
  if (containsStickyAtc) tasks.push(loadStickyAddToCartModules());

  const containsRentalBundle = root.matches?.('rental-bundle-builder') || root.querySelector?.('rental-bundle-builder');
  if (containsRentalBundle) tasks.push(loadRentalBundleModules());

  const containsShopTheLook = root.matches?.('shop-the-look') || root.querySelector?.('shop-the-look');
  if (containsShopTheLook) tasks.push(loadShopTheLookModules());

  const containsBeforeAfter = root.matches?.('before-after-slider') || root.querySelector?.('before-after-slider');
  if (containsBeforeAfter) tasks.push(loadBeforeAfterModules());

  const containsCountdown = root.matches?.('countdown-timer') || root.querySelector?.('countdown-timer');
  if (containsCountdown) tasks.push(loadCountdownModules());

  const containsMarquee = root.matches?.('scrolling-marquee') || root.querySelector?.('scrolling-marquee');
  if (containsMarquee) tasks.push(loadMarqueeModules());

  if (root.matches?.('product-coupon, discount-progress, product-video-shopping') || root.querySelector?.('product-coupon, discount-progress, product-video-shopping')) {
    productPromotionModules ||= import(runtime.assets.productPromotions);
    tasks.push(productPromotionModules);
  }

  if (tasks.length) await Promise.all(tasks);
}

let editorLoading = null;
async function initThemeEditor() {
  if (editorLoading) return editorLoading;
  if (runtime?.assets?.themeEditor) {
    editorLoading = import(runtime.assets.themeEditor).then((editor) => {
      editor.initializeThemeEditor(mount);
      return editor;
    }).catch((error) => {
      editorLoading = null;
      console.error('[Theme editor load error]', error);
    });
    return editorLoading;
  }
}

async function bootstrap() {
  try {
    await import(runtime.assets.cartStore);
    await import(runtime.assets.cartOverlay);
    await import(runtime.assets.cartComponents);
    await import(runtime.assets.shippingCalculator);
    await mount(document);

    const isDesignMode = Boolean(
      runtime?.designMode ||
      globalThis.Shopify?.designMode ||
      document.body?.hasAttribute('data-theme-editor') ||
      globalThis.window?.location?.search?.includes('preview_theme_id')
    );

    if (isDesignMode) {
      await initThemeEditor();
    }
  } catch (error) {
    console.error('[Theme bootstrap]', error);
  }
}

// Early listener fallback: ensure editor is initialized if shopify events fire
if (typeof document !== 'undefined') {
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:select', 'shopify:section:deselect', 'shopify:section:reorder', 'shopify:block:select', 'shopify:block:deselect'].forEach((eventType) => {
    document.addEventListener(eventType, () => {
      initThemeEditor();
    }, { once: true });
  });
}

document.addEventListener('listing:render', () => {
  mount(document);
});

document.addEventListener('listing:append', (event) => {
  if (event.detail?.items?.length) {
    event.detail.items.forEach((item) => mount(item));
  }
});

window.ThemeBootstrap = {
  mount,
  loadProductModules,
  loadProductCardModules,
  loadFacetsModules,
  loadInfiniteLoaderModules,
  loadPredictiveSearchModules,
  loadOverlayModules,
  loadAccordionModules,
  loadTabsModules,
  loadCarouselModules,
  loadPopoverModules,
  loadMotionModules,
  loadHeaderModules,
  loadProductRecommendationsModules,
  loadRecentlyViewedModules,
  loadStickyAddToCartModules,
  loadRentalBundleModules,
  loadShopTheLookModules,
  loadBeforeAfterModules,
  loadCountdownModules,
  loadMarqueeModules
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
} else {
  bootstrap();
}
